import axiosClient from './axiosClient';

const questionApi = {
  create: (data) => {
    const url = '/questions';
    return axiosClient.post(url, data);
  },
  edit: (params, data) => {
    const url = '/questions';
    return axiosClient.put(url, data, { params });
  },
  get: (params) => {
    const url = '/questions/get-questions';
    return axiosClient.get(url, { params });
  },
  getById: (params) => {
    const url = '/questions';
    return axiosClient.get(url, { params });
  },
  delete: (params) => {
    const url = '/questions';
    return axiosClient.delete(url, { params });
  },
  //Ai Create Quiz Api
  createQuiz: async (params, data) => {
    const url = `/questions/generate-quiz-from-file`;
    const response = await axiosClient.post(url, data, {
      params,
    });
    return response;
  },
  proceedQuiz: async (id, data) => {
    const url = `/questions/ai-quiz/submit/${id}`;
    const response = await axiosClient.post(url, data);
    return response;
  },
  history: async (params) => {
    const url = '/questions/ai-quiz/history';
    const response = await axiosClient.get(url, { params });
    return response;
  },
  view: async (id) => {
    const url = `/questions/ai-quiz/view-history/${id}`;
    return axiosClient.get(url);
  },
  deleteHistory: (id) => {
    const url = `/questions/ai-quiz/history/${id}`;
    return axiosClient.delete(url);
  },
  questionDelete: (id) => {
    const url = `/questions/ai-question/${id}`;
    return axiosClient.delete(url);
  },
  getAvailableQuestions: (data) => {
    const url = '/questions/available-questions';
    return axiosClient.post(url, data);
  },
  // getAvailableQuestions: (params) => {
  //   const url = '/questions/available-questions';
  //   return axiosClient.get(url, { params });
  // },
};

export default questionApi;
